<ng-template #dateContent>
  @if (dayDifference() >= 0 && dayDifference() <= 1) {
    <span i18n="@@expectedDeliveryByTomorrow"> Expected delivery by <span class="tw-font-bold">tomorrow</span> </span>
  } @else if (dayDifference() === 2) {
    <span i18n="@@expectedDeliveryIn2Days"> Expected delivery in <span class="tw-font-bold">2 days</span> </span>
  } @else if (dayDifference() === 3) {
    <span i18n="@@expectedDeliveryIn3Days"> Expected delivery in <span class="tw-font-bold">3 days</span> </span>
  } @else {
    <span i18n="@@expectedDeliveryIn3to5Days"> Expected delivery in <span class="tw-font-bold">3-5 days</span></span>
  }
</ng-template>

@if (expectedDeliveryDate()?.from && expectedDeliveryDate()?.to) {
  @if (variant() === VARIANT.BADGE) {
    <span class="tw-inline-flex tw-bg-gray-100 tw-rounded tw-px-3 tw-py-1 tw-text-200 tw-font-lexend tw-font-normal tw-text-gray-500">
      <ng-container *ngTemplateOutlet="dateContent" />
    </span>
  } @else {
    <p class="tw-mt-1.5 tw-text-center tw-text-200 tw-font-lexend tw-font-normal tw-text-gray-500">
      <ng-container *ngTemplateOutlet="dateContent" />
    </p>
  }
}
